import { Badge } from '@/components/ui/badge'
import type { StepRequirementSummary } from '@/utils/membership/types'
import { CheckCircle2, Circle } from 'lucide-react'

interface RequirementSummaryListProps {
  title?: string
  summaries: StepRequirementSummary[]
  className?: string
  emptyLabel?: string
}

export function RequirementSummaryList({
  title,
  summaries,
  className,
  emptyLabel,
}: RequirementSummaryListProps) {
  if (!summaries || summaries.length === 0) {
    return emptyLabel ? (
      <div className={className}>{emptyLabel}</div>
    ) : null
  }

  return (
    <div className={className}>
      {title ? <h3 className="text-sm font-semibold text-muted-foreground">{title}</h3> : null}
      <ul className="mt-2 space-y-2 text-sm">
        {summaries.map((summary) => (
          <li key={summary.id ?? summary.label} className="flex gap-3 rounded-md border border-border bg-muted/30 p-3">
            <span className="mt-1 text-muted-foreground">
              {summary.mandatory ? (
                <CheckCircle2 className="h-4 w-4 text-primary" />
              ) : (
                <Circle className="h-4 w-4" />
              )}
            </span>
            <div className="flex-1 space-y-1">
              <div className="flex items-center gap-2">
                <span className="font-medium text-foreground">{summary.label}</span>
                <Badge variant={summary.mandatory ? 'destructive' : 'outline'} className="h-5 text-xs">
                  {summary.mandatory ? 'Required' : 'Optional'}
                </Badge>
              </div>
              {summary.description ? (
                <p className="text-xs text-muted-foreground">{summary.description}</p>
              ) : null}
              {summary.acceptedFormats && summary.acceptedFormats.length > 0 ? (
                <p className="text-xs text-muted-foreground">
                  Accepted formats: {summary.acceptedFormats.join(', ')}
                </p>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
